import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import "./filters"

Vue.use(Vuetify);

const vuetifyOptions = { 
  iconfont: 'md'
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify: new Vuetify(vuetifyOptions),
  render: h => h(App),
}).$mount('#app');



router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if ( !store.state.user ) {
      next({
        path: '/user'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})
